export default __webpack_public_path__ + "static/media/mountain_walker_thumb.9776d16b.png";